module.exports = __webpack_public_path__ + "static/media/facebook-circle.b242e861.svg";